<template>
  <div class="content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Content'
}
</script>

<style lang="less" scoped>
.content {
	width: 100%;
	border-radius: 8px;
}

</style>
